import React from 'react';
import SelectComponent from "../../chrome/elements/selectComponent";
import selectPlatform from "../../../util/selectPlatform";
import { subscribe } from 'react-contextual';

const SelectByPlatform = ({subdomain, children}) => (
    <SelectComponent name={selectPlatform(subdomain)}>
        {children}
    </SelectComponent>
);

export default subscribe()(SelectByPlatform);
